import { calculateSeconds } from './utils';

// Normalize URL format differences between axios config and Performance API for consistent matching
const normalizeUrl = (url) => {
  const urlObj = new URL(url, location.origin); 
  return urlObj.pathname + decodeURIComponent(urlObj.search);
}


// Simple browser performance tracking for any endpoint
export const getBrowserPerformanceTiming = (url) => {
  const resourceEntries = performance.getEntriesByType('resource');
  const resourceEntry = resourceEntries.find(entry => normalizeUrl(entry.name) === normalizeUrl(url));
  
  if (!resourceEntry) return null;
  
  return {
    // Browser internal queuing time - difference between when fetch started and when request started
    // This indicates if the browser is busy processing other tasks before initiating this request
    // Critical metric: High values suggest browser performance bottlenecks, most of the time it will come as negligible number, as browser handle this phase efficiently
    browserQueuedTimeSec: calculateSeconds(resourceEntry.fetchStart, resourceEntry.startTime),
    
    // Browser stalled time - difference between when connection started and when fetch started
    // Browser allows max 6 parallel connections per origin (HTTP/1.x). When exceeded, requests stall
    // Critical metric: High values indicate connection contention and potential request throttling needed
    browserStalledTimeSec: calculateSeconds(resourceEntry.requestStart, resourceEntry.fetchStart),
    
    // Server processing time - difference between first response byte received and request sent
    // Server processing + network transmission time
    serverProcessingTimeSec: calculateSeconds(resourceEntry.responseStart, resourceEntry.requestStart),
    
    // Total end-to-end request time - difference between response completed and request started
    // Complete request lifecycle from start to finish
    totalRequestTimeSec: calculateSeconds(resourceEntry.responseEnd, resourceEntry.startTime)
  };
};

// Get browser performance timing data for any URL
export const getBrowserPerformanceData = (pickupOperationTimeTrackingId, url) => {
  if (!url || !pickupOperationTimeTrackingId) return null;
  
  const timing = getBrowserPerformanceTiming(url);
  if (!timing) return null;
  
  return {
    endpoint: url,
    ...timing,
    pickupOperationTimeTrackingId
  };
};

// Store browser performance data in pickup operation tracking and log it
export const storeBrowserPerformanceData = ({ pickupOperationTrackingData, apiType, url }) => {
  if (!url || !pickupOperationTrackingData) return;
  
  const timing = getBrowserPerformanceTiming(url);
  if (!timing) return;
  
  const performanceData = {
    endpoint: url,
    ...timing,
    pickupOperationTimeTrackingId: pickupOperationTrackingData.pickupOperationTimeTrackingId
  };
  
  // Store in the appropriate browserPerformance field
  pickupOperationTrackingData.browserPerformance[apiType] = performanceData;
};